import { render } from "./product-order.vue?vue&type=template&id=691f8896"
import script from "./product-order.vue?vue&type=script&lang=js"
export * from "./product-order.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__